import {ColorInterpolation} from '../../classes/ColorInterpolation';

declare let THREE: any;

export class HemisphereLight extends (THREE.HemisphereLight as { new(skyColor?, groundColor?, intensity?): any; }) {

  private skyColorInterpolation: ColorInterpolation;
  private groundColorInterpolation: ColorInterpolation;

  constructor(
    skyColorInterpolation: ColorInterpolation,
    groundColorInterpolation: ColorInterpolation,
    intensity: number
  ) {
    super(skyColorInterpolation.getStart(), groundColorInterpolation.getStart(), intensity);
    this.position.set(0, 10, 0);
    this.name = 'gridHemi';
    this.skyColorInterpolation = skyColorInterpolation;
    this.groundColorInterpolation = groundColorInterpolation;
  }

  interpolateColor(input: number) {
    this.color.copy(
      this.skyColorInterpolation.interpolate(input)
    );
    this.groundColor.copy(
      this.groundColorInterpolation.interpolate(input)
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/env/HemisphereLight.ts